import { render, staticRenderFns } from "./keyProjectTypeSideView.vue?vue&type=template&id=2e6afde5"
import script from "./keyProjectTypeSideView.vue?vue&type=script&lang=js"
export * from "./keyProjectTypeSideView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports